import { StatusVm } from './StatusVm'
import { BusinessVm } from './BusinessVm';

export class BusinessCardVm{
    CardDataId:number = 0;
    Id: number = 0;
    CardNumber: string = "";
    BusinessName: string = "";
    ValidFrom: Date | null = null;
    ValidTo: Date | null = null;
    Status: StatusVm = new StatusVm();
    Business: BusinessVm = new BusinessVm();

}
